import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { capitalize } from '@attain-apps/string-utils'

import * as state from '../../../../../../../../state'
import * as variablesBuilder from '../../../../../variables-builder'
import * as dialogs from '../dialogs'

@ngCore.Component({
  imports: [
    variablesBuilder.table.Component,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    ds.input.text.Component,
    dialogs.variable.Component,
  ],
  selector: 'atn-widget-builder-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.widgets.Collection} */
  private readonly _widgetsEc = ngCore.inject(
    state.mosaic.dev.widgets.Collection,
  )

  /** Name of the creating/editing widget */
  public readonly widgetNameSg = ngCore.computed(
    (
      widget = this._widgetsEc.plugins.currentEntityPlugin.feature.selectors
        .getLatestEntity()
        .asSignal(),
    ) => widget?.name,
  )

  /** Alias of the creating/editing widget */
  public readonly widgetAliasSg = ngCore.computed(
    (
      widget = this._widgetsEc.plugins.currentEntityPlugin.feature.selectors
        .getLatestEntity()
        .asSignal(),
    ) => widget?.alias,
  )

  /** Description of the creating/editing widget */
  public readonly widgetDescriptionSg = ngCore.computed(
    (
      widget = this._widgetsEc.plugins.currentEntityPlugin.feature.selectors
        .getLatestEntity()
        .asSignal(),
    ) => widget?.description,
  )

  /**
   * Updates a specific property of the currently edited widget.
   */
  public updateWidget<K extends keyof ents.core.mosaic.Widget.Input>(
    prop: K,
    value: ents.core.mosaic.Widget.Input[K],
  ): void {
    this._widgetsEc.plugins.editingPlugin.feature.actions.edit
      .from(`Dialog.${capitalize(prop)}.Inputted`)
      .dispatch({
        edit: widget => {
          if (!widget) {
            return
          }
          widget[prop] = value
        },
        id: this._widgetsEc.plugins.currentEntityPlugin.feature.selectors
          .getId()
          .asSignal(),
      })
  }
}
